"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n    z-index: 2;\n    position: relative;\n    transition-property: background;\n    ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var base = function base(_ref) {
  var theme = _ref.theme,
      disabled = _ref.disabled,
      focused = _ref.focused;
  var palette = theme.palette;
  return {
    backgroundColor: disabled ? theme.disabledSelectedBackground : focused ? theme.focusSelectedBackground : theme.selectedBackground,
    height: theme.height,
    borderRadius: theme.borderRadius,
    transitionDuration: palette.transitionDuration,
    transitionTimingFunction: palette.transitionFunction
  };
};

var Bar = _styledComponents["default"].div(_templateObject(), function (props) {
  return base(props);
});

var _default = Bar;
exports["default"] = _default;